import React from "react";
import { useHistory } from "react-router-dom";
import { BotGlyph } from "./AgentsList";

/**
 * Header breadcrumb for every agents page, matching Copilot's: the icon + "Agents"
 * always goes back to the full agents list (filters and folder reset), then the
 * page you're on. Own component so the shared breadcrumb stays untouched.
 */
const AgentsCrumb = ({ items = [] }) => {
  const history = useHistory();
  return (
    <nav className="ag-crumb" aria-label="Breadcrumb">
      <button
        type="button"
        className="ag-crumb__home"
        onClick={() => history.push({ pathname: "/agents", state: { resetAgents: Date.now() } })}
      >
        <BotGlyph size={17} />
        <span>Agents</span>
      </button>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <span className="ag-crumb__sep" aria-hidden="true">/</span>
          {it.to && i < items.length - 1 ? (
            <button type="button" className="ag-crumb__link" onClick={() => history.push(it.to)}>{it.label}</button>
          ) : (
            <span className="ag-crumb__here" aria-current="page">{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default AgentsCrumb;
